import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, forwardRef } from "react";
import Loader from "react-spinner-loader";
import {

  Viewicon,

  // Replaceicon
} from "../../../../Components/IconComponents";

//import { Modal, Button } from "react-bootstrap";
import {
  contactTableData,

} from "../../../../JsonData/ContactConfig";
import {

  getResourceDeploy,
  getReleaseResourceDeploy,
  vehiclerelease,
  getThemeURL
} from "../../../../Services/EndPoints";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getData, putDataWithBody } from "../../../../Services/Services";


import { useTranslation } from "react-i18next";
import { RoleContext } from "../../../..";

import { Modal, Button } from "react-bootstrap";

import DeploymentListExpandableTable from "./DeploymentListExpandableTable";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Download, Sheet } from "lucide-react";
import ExcelJS from "exceljs";

// const ResourceReleaseIconOpen = ({ className, onClick }) => (
//   <svg
//     className={className}
//     onClick={onClick}
//     width="19"
//     height="19"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     style={{ cursor: 'pointer' }}
//   >
//     {/* Open shackle to the left */}
//     <path
//       d="M17 11V7a5 5 0 00-9.9-1" // flipped shackle arc
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />

//     {/* Lock body */}
//     <rect
//       x="4"
//       y="11"
//       width="16"
//       height="10"
//       rx="2"
//       stroke="currentColor"
//       strokeWidth="2"
//     />

//     {/* Keyhole */}
//     <circle cx="12" cy="16" r="1" fill="currentColor" />
//   </svg>
// );

const ResourceReleaseIconOpen = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer' }}
  >
    {/* Completely open shackle - detached U-shape to the left */}
    <path
      d="M2 8V6a4 4 0 018 0v2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* Lock body */}
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />

    {/* Keyhole */}
    <circle cx="12" cy="16" r="1" fill="currentColor" />
  </svg>
);

const ResourceReleaseIconClose = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer' }}
  >
    {/* Closed shackle */}
    <path
      d="M8 11V7a4 4 0 118 0v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />

    {/* Lock body */}
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />

    {/* Keyhole */}
    <circle cx="12" cy="16" r="1" fill="currentColor" />
  </svg>
);


const DeploymentList = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const dispatch = useDispatch();
  console.log("jjj", dispatch)
  const qs = require("qs");
  const [userData, setUserData] = useState(contactTableData);
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const { t, } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  const [ResourceData, setResourceData] = useState([]);
  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [statename, setStatename] = useState(null);
  const [incidentBanner, setIncidentBanner] = useState(null); // { found: bool, name: string }
  const [matchBanner, setMatchBanner] = useState(null); // { found, count, label, fromIncident }

  // Deployment record ids (reference_id) passed from View Incident → Quick Links
  // "Resources Deployed / Released". A parent row matches when any of its
  // deployed_resource_list entries has an id in this set; matched rows are bold.
  const highlightDeployIds = (location.state?.highlightDeployIds || []).map((v) => String(v));

  console.log(searchData,statename, "searchuserdata");

  console.log("jiii", setUserData)

  console.log("jiii1", setRowCount)

  console.log("jiii13", qs)

 const getUserProfile = async () => {
  try {
    const profile = await getData(getThemeURL);
    if (profile && profile.length > 0) {
      setStateId(profile[0].state_id);
      setStatename(profile[0].statename)
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
  }
};
 useEffect(() => {
    getUserProfile();
  }, []);

  
  useEffect(() => {
  // if (stateId) {
    getResourceDeployList();
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId]);


  const getResourceDeployList = async () => {
    try {
      setLoader(true);
  console.log(stateId,"siddddddddddddddddddddddddddddd")
      const viewData = await getData(getResourceDeploy.replace("STATEID", stateId));
      const processedData = viewData
        .map((item, index) => {
          // Get all unique incident names
          const incidentNames = [...new Set(
            (item.deployed_resource_list || [])
              .filter(d => d.incident_name)
              .map(d => d.incident_name)
          )].join(", ");

          // Get all unique incident IDs (incident_seq_id)
          const incidentSeqIds = [...new Set(
            (item.deployed_resource_list || [])
              .filter(d => d.incident_seq_id)
              .map(d => d.incident_seq_id)
          )].join(", ");

          return {
            ...item,
            id: index,
            incident_name: incidentNames || "NA", // Add incident_name at resource level
            incident_seq_id: incidentSeqIds || item.incident_seq_id || "NA",
            deployedResourceList: (item.deployed_resource_list || [])
              .sort((a, b) => new Date(b.deployed_date_and_time) - new Date(a.deployed_date_and_time))
          };
        })
        .sort((a, b) => {
          const getLatestDate = (resource) => {
            if (!resource.deployedResourceList || resource.deployedResourceList.length === 0) return 0;
            return Math.max(...resource.deployedResourceList.map(d => new Date(d.deployed_date_and_time)));
          };
          return getLatestDate(b) - getLatestDate(a);
        });

      setResourceData(processedData);

      const navIncidentId = location.state?.incidentId;
      const navIncidentName = location.state?.incidentName;
      if (navIncidentId) {
        const matched = processedData.find(
          (item) => String(item.incident_id) === String(navIncidentId)
        );
        const displayName = matched?.incident_name || navIncidentName || String(navIncidentId);
        setIncidentBanner({ found: !!matched, name: displayName });
      }

      if (highlightDeployIds.length) {
        const matchedCount = processedData.filter((item) =>
          (item.deployed_resource_list || []).some((d) =>
            highlightDeployIds.includes(String(d.id))
          )
        ).length;
        setMatchBanner({
          found: matchedCount > 0,
          count: matchedCount,
          label: location.state?.sourceLabel || "deployment",
          fromIncident: location.state?.fromIncident || "",
        });
      }
    } catch (error) {
      console.error("Error fetching resource data:", error);
      toast.error("Failed to fetch resource data", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };




  const handleReplaceClick = (resource) => {
    setSelectedResource(resource);
    setShowReleaseModal(true);
  };

  const handleRelease = async () => {
    try {
      setLoader(true);

      const deployedResources = selectedResource.deployed_resource_list || [];
      const deployedResourcesOnly = deployedResources.filter(item => item.is_deployed);

      const requestData = deployedResourcesOnly.map(deployedItem => ({
        resourceId: selectedResource.resource_id,
        id: deployedItem.id
      }));

      if (requestData.length === 0) {
        toast.error("No deployed resources found to release", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setLoader(false);
        return;
      }
      let vehicleDeployIds = [];
      const response = await putDataWithBody(getReleaseResourceDeploy, requestData, {});

      if (response.status === "success" || response.status === "multi-status") {
        const allSuccessful = response.results?.every(r => r.status === "success");

        vehicleDeployIds = deployedResourcesOnly
          .flatMap(item => item.vehicles || []) // Get all vehicles from all deployed resources
          .filter(vehicle => vehicle.vehicle_deploy_id && vehicle.is_deployed) // Only deployed vehicles with IDs
          .map(vehicle => vehicle.vehicle_deploy_id);
        if (allSuccessful) {

          if (vehicleDeployIds.length > 0) {
            await putDataWithBody(vehiclerelease, vehicleDeployIds, {});
          }
          toast.success("Resource(s) released successfully", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        } else {
          const failed = response.results?.filter(r => r.status !== "success");
          toast.error(`Some resources failed to release: ${failed.map(f => f.msg).join(', ')}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
        getResourceDeployList();
      } else {
        toast.error(response.msg || "Failed to release resource", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error releasing resource:", error);
      toast.error("An error occurred while releasing the resource", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
      setShowReleaseModal(false);
    }
  };

  const handleDownload = async () => {
    try {
      setLoader(true);

      // Create a new workbook
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Deployment List');

      // Define columns
      worksheet.columns = [
        { header: 'Deployment ID', key: 'deploymentId', width: 22 },
        { header: 'Incident ID', key: 'incidentSeqId', width: 22 },
        { header: 'Incident Name', key: 'incidentName', width: 40 },
        { header: 'Resource Name', key: 'resourceName', width: 40 },
        { header: 'Agency Name', key: 'resourceAgencyName', width: 50 },
        { header: 'Region Name', key: 'regionName', width: 20 },
        { header: 'Resource Facility Name', key: 'resourceFacilityName', width: 40 },
        { header: 'Available Quantity', key: 'availableQuantity', width: 18 },
        { header: 'Deployed Quantity', key: 'deployedQuantity', width: 18 },
        { header: 'Deployed Facility Name', key: 'deployFacilityName', width: 40 },
        { header: 'Deployed Quantity', key: 'deployQuantity', width: 18 },
        // { header: 'Deployed Quantity Updated By', key: 'deployQuantityUpdatedBy', width: 18 },
        // { header: 'Deployed Quantity Updated Date & Time', key: 'deployQuantityUpdatedDateTime', width: 18 },
        { header: 'Deployment Type', key: 'deploymentType', width: 20 },
        { header: 'Deployed Date and Time', key: 'deployedDate', width: 30 },
        { header: 'Released Date and Time', key: 'releasedDate', width: 30 },
        { header: 'Deployed By', key: 'deployedBy', width: 25 },
        { header: 'Released By', key: 'releasedBy', width: 25 },
        { header: 'Status', key: 'status', width: 15 }
      ];

      // Function to format date to 12-hour format
      const formatTo12Hour = (dateString) => {
        if (!dateString || dateString === 'N/A') return dateString;

        try {
          const date = new Date(dateString);
          return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          }).replace(/\//g, '-');
        } catch (e) {
          console.error('Error formatting date:', e);
          return dateString;
        }
      };

      // Add data rows
      ResourceData.forEach(resource => {
        const deployedResources = resource.deployed_resource_list || [];
        const totalDeployedQuantity = deployedResources
          .filter(item => item.is_deployed)
          .reduce((sum, item) => sum + (item.deploy_quantity || 0), 0);

        // If no deployed resources, add just the parent row
        if (deployedResources.length === 0) {
          worksheet.addRow({
            deploymentId: resource.deployment_id || "N/A",
            incidentSeqId: resource.incident_seq_id || "N/A",
            incidentName: resource.incident_name || "N/A",
            resourceName: resource.resource_name,
            resourceAgencyName: resource.resource_agency_name,
            regionName: resource.resource_region_name,
            resourceFacilityName: resource.resource_facility_name,
            availableQuantity: resource.available_quantity,
            deployedQuantity: totalDeployedQuantity
          });
        } else {
          // Add a row for each deployed resource with full parent data
          deployedResources.forEach((deployed) => {
            worksheet.addRow({
              deploymentId: deployed.deployment_id || resource.deployment_id || "N/A",
              incidentSeqId: deployed.incident_seq_id || resource.incident_seq_id || "N/A",
              incidentName: deployed.incident_name || resource.incident_name || "N/A",
              resourceName: resource.resource_name,
              resourceAgencyName: resource.resource_agency_name,
              regionName: resource.resource_region_name,
              resourceFacilityName: resource.resource_facility_name,
              availableQuantity: resource.available_quantity,
              deployedQuantity: totalDeployedQuantity,
              deployFacilityName: deployed.deploy_facility_name,
              deployQuantity: deployed.deploy_quantity,
              deployQuantityUpdatedBy: deployed.updated_by || "N/A",
              deployQuantityUpdatedDateTime: formatTo12Hour(deployed.updated_on) || "N/A",
              deploymentType: deployed.is_auto_triggered ? 'Automatic' : 'Manual',
              deployedDate: formatTo12Hour(deployed.deployed_date_and_time),
              releasedDate: formatTo12Hour(deployed.released_date_and_time) || 'N/A',
              deployedBy: deployed.deployed_by,
              releasedBy: deployed.released_by || 'N/A',
              status: deployed.is_deployed ? 'Deployed' : 'Released'
            });
          });
        }
      });

      // Auto-filter
      worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: { row: 1, column: worksheet.columns.length }
      };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Resource_Deployment_List.xlsx';
      a.click();
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error generating Excel:', error);
      toast.error('Failed to generate Excel file', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setShowReleaseModal(false);
  };

  // const addNewHandler = () => {
  //   navigate("/users/create-user");
  // };

  // const getShortenedText = (strLength, fulltext) => {
  //   let abbreviatedText = "";
  //   if (fulltext.length > strLength) {
  //     abbreviatedText = fulltext.substring(0, 15) + "...";
  //   } else {
  //     abbreviatedText = fulltext;
  //   }
  //   return <span title={fulltext}>{abbreviatedText}</span>;
  // };
  // const getUserList = async () => {
  //   setLoader(true);
  //   var userList = await getData(getUsersFromApp);
  //   setLoader(false);
  //   userList.forEach(value => {
  //     // user_role_map
  //     value.user_role_map_forSearch = value.user_role_map?.map(role => role.roleEntity.name).join(", ") || "NA";
  //   })
  //   console.log('ssss',userList);
  //   setUserData(userList);
  //   setRowCount(userList.length);
  // };
  //   useEffect(() => {
  //     if (props.locationInstance && props.locationInstance.msg != "") {
  //       toast.success("Agency has been created successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //         autoClose: 2000, // Close after 2 seconds
  //       });
  //     }
  //     getAgecnyList();
  //   }, []);

  // const sendDataToCentralStore = (data) => {
  //   console.log(data, "USERDATA");
  //   if (data.length > 0) {
  //     const columns = userTableDatacolumnsForExport;

  //     const processedData = data.map((item) => ({
  //       ...item,
  //       full_name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
  //       // Format the createdOn date as DD/MM/YYYY, HH:mm
  //       createdOn: item.createdOn
  //         ? new Date(item.createdOn).toLocaleDateString('en-GB') + ', ' + new Date(item.createdOn).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  //         : "NA",
  //     }));

  //     console.log("PRdataForuser", processedData);
  //     dispatch(
  //       setTableData({
  //         columns,
  //         tableData: getExportedColumnsData(columns, processedData),
  //       })
  //     );
  //   }
  // };
  const handleViewDetails = (resource) => {
    console.log("resource34344", resource)
    // Navigate to details page with resource data
    navigate("/Active-panellist", {
      state: { resourceData: resource }
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Deployment ID",
        accessor: "deployment_id",
        disableSortBy: true,
      },
      {
        Header: t("resourceallocationlistheaders.incidentname"),
        accessor: "incident_name",
        disableSortBy: true,
        Cell: ({ row }) => {
          const incidentSeqId = row.original.incident_seq_id;
          return (
            <div>
              <div>{row.original.incident_name}</div>
              {incidentSeqId && incidentSeqId !== "NA" && (
                <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: "2px" }}>
                  {incidentSeqId}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: t("resourceallocationlistheaders.rname"),
        accessor: "resource_name",
        disableSortBy: true,
        Cell: ({ row }) => {
          const sopInstanceName = row.original.sop_instance_name;
          return (
            <div>
              <div>{row.original.resource_name}</div>
              {sopInstanceName && (
                <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: "2px" }}>
                  {sopInstanceName}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: t("resourceallocationlistheaders.raname"),
        accessor: "resource_agency_name",
        disableSortBy: true,
      },
      {
        Header: t("resourceallocationlistheaders.bname"),
        accessor: "resource_region_name",
        disableSortBy: true,
      },
      {
        Header: t("resourceallocationlistheaders.rfname"),
        accessor: "resource_facility_name",
        disableSortBy: true,
      },
      {
        Header: t("resourceallocationlistheaders.aquantity"),
        accessor: "available_quantity",
        disableSortBy: true,
        Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,
      },
      {
        Header: t("resourceallocationlistheaders.quantity"),
        accessor: "deployed_resource_list",
        disableSortBy: true,
        Cell: ({ value }) => {
          // Filter items where is_deployed is true and sum their deploy_quantity
          const totalQuantity = value
            ?.filter(item => item.is_deployed === true)
            .reduce((sum, item) => sum + (item.deploy_quantity || 0), 0) || 0;
          return <div style={{ textAlign: 'center' }}>{totalQuantity}</div>;
        }
      },
      {
        Header: t("resourceallocationlistheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const hasDeployedResources = props.row.original.deployed_resource_list?.some(item => item.is_deployed) || false;

          const hasTransportationActivity = props.row.original.deployed_resource_list?.some(
            item => item.is_deployed && item.rsrc_activity_id === "Transportation"
          ) || false;
console.log(hasTransportationActivity)
          const resource = props.row.original;

          const releaseAllTooltip = (
            <Tooltip id="release-all-tooltip">
              Released All Resources
            </Tooltip>
          );

          const deployedTooltip = (
            <Tooltip id="deployed-tooltip">
              Deployed Resources (Click to Release All)
            </Tooltip>
          );

          const viewTooltip = (
            <Tooltip id="view-tooltip">
              View Resource Details
            </Tooltip>
          );

          return (
            <div
              className="usertable__actionsicon d-flex align-items-center justify-content-center"
              style={{
                minWidth: '80px',
                height: '100%',
                margin: 'auto'
              }}
            >
              {/* View Icon - Only visible when there are deployed resources with Transportation activity */}
              {hasDeployedResources  ? (
                <OverlayTrigger placement="top" overlay={viewTooltip}>
                  <span
                    onClick={() => handleViewDetails(resource)}
                    className="cursor-pointer me-3"
                    style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                  >
                    <Viewicon className="cursor-pointer" />
                  </span>
                </OverlayTrigger>
              ) : (
                <span className="me-3" style={{ width: '19px', display: 'inline-block' }}></span>
              )}

              {/* Release Icon - Conditional based on deployment status */}
              {hasDeployedResources ? (
                <OverlayTrigger placement="top" overlay={deployedTooltip}>
                  <span
                    onClick={() => handleReplaceClick(resource)}
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                  >
                    <ResourceReleaseIconClose className="cursor-pointer" />
                  </span>
                </OverlayTrigger>
              ) : (
                <OverlayTrigger placement="top" overlay={releaseAllTooltip}>
                  <span style={{ opacity: 0.5, cursor: 'not-allowed', display: 'inline-flex', alignItems: 'center' }}>
                    <ResourceReleaseIconOpen />
                  </span>
                </OverlayTrigger>
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, roleName]
  );

  const handleResourceReleaseFromExpandedTable = async (resourceData) => {
    console.log("refresh", resourceData)
    try {
      setLoader(true);

      // Prepare the request data
      const requestData = [{
        resourceId: resourceData.resource_id,
        id: resourceData.selectedDeployment?.id || resourceData.id
      }];

      // Call the release endpoint
      const response = await putDataWithBody(getReleaseResourceDeploy, requestData, {});

      if (response.status === "success") {
        const vehicleDeployIds = (resourceData.selectedDeployment?.vehicles || [])
          .filter(vehicle => vehicle.vehicle_deploy_id && vehicle.is_deployed)
          .map(vehicle => vehicle.vehicle_deploy_id);

        // Only call vehicle release if there are vehicle IDs
        if (vehicleDeployIds.length > 0) {
          try {
            await putDataWithBody(vehiclerelease, vehicleDeployIds, {});
          } catch (err) {
            console.error("Error releasing vehicles:", err);
          }
        }
        toast.success("Resource released successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });

        // Force a refresh of the table data
        await getResourceDeployList();
      } else {
        toast.error(response.msg || "Failed to release resource", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error releasing resource:", error);
      toast.error("An error occurred while releasing the resource", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };

  console.log(userData, "userdata");
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      {/* <div className="d-flex justify-content-end mt-0 mb-0" style={{ marginRight: "230px", position: "relative", zIndex: 10, }}>
        <button
          className="btn btn-success btn-sm flood__report--button"
          onClick={handleDownload}
        >
          Download
        </button>
      </div> */}
      {/* <div className="d-flex justify-content-end mt-0 mb-0" style={{ marginRight: "230px", position: "relative", zIndex: 10, }}>
        <button
          className="btn btn-success btn-sm flood__report--button"
          onClick={handleDownload}
        >
          Download
        </button>
      </div> */}
      {incidentBanner && (
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 16px",
          borderRadius: "8px",
          border: `1px solid ${incidentBanner.found ? "#93c5fd" : "#fca5a5"}`,
          background: incidentBanner.found ? "#eff6ff" : "#fff1f2",
          color: incidentBanner.found ? "#1d4ed8" : "#dc2626",
          fontSize: "13px",
          marginBottom: "12px",
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span style={{ flex: 1 }}>
            {incidentBanner.found ? "Showing resources for incident:" : "No related resources found for incident:"}
            {" "}<strong>{incidentBanner.name}</strong>
          </span>
          <span
            onClick={() => setIncidentBanner(null)}
            style={{ cursor: "pointer", fontSize: "16px", lineHeight: 1, opacity: 0.6 }}
          >✕</span>
        </div>
      )}
      {matchBanner && (
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 16px",
          borderRadius: "8px",
          border: `1px solid ${matchBanner.found ? "#93c5fd" : "#fca5a5"}`,
          background: matchBanner.found ? "#eff6ff" : "#fff1f2",
          color: matchBanner.found ? "#1d4ed8" : "#dc2626",
          fontSize: "13px",
          marginBottom: "12px",
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span style={{ flex: 1 }}>
            {matchBanner.found
              ? <>Highlighting <strong>{matchBanner.count}</strong> {matchBanner.label} record(s){matchBanner.fromIncident ? <> from incident <strong>{matchBanner.fromIncident}</strong></> : null}</>
              : <>No matching {matchBanner.label} record(s) found{matchBanner.fromIncident ? <> for incident <strong>{matchBanner.fromIncident}</strong></> : null}</>}
          </span>
          <span
            onClick={() => setMatchBanner(null)}
            style={{ cursor: "pointer", fontSize: "16px", lineHeight: 1, opacity: 0.6 }}
          >✕</span>
        </div>
      )}
      <div className="datatable__container resource-alloc-table" style={{ marginTop: "0px", position: "relative" }}>
        {ResourceData?.length > 0 && (
          <button
            onClick={handleDownload}
            title="Export to Excel"
            style={{
              position: "absolute",
              top: "14px",
              right: "20px",
              zIndex: 10,
              padding: "8px 12px",
              backgroundColor: "#10B981",
              color: "white",
              border: "none",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
              fontWeight: "500",
              height: "36px",
              fontSize: "12px",
            }}
          >
            <Download size={14} />
            <Sheet size={14} />
          </button>
        )}
        {/* <Table */}
        <DeploymentListExpandableTable
          data={ResourceData}
          columns={columns}
          highlightedIncidentId={location.state?.incidentId}
          highlightDeployIds={highlightDeployIds}
          numberOfRows={10}
          setSearchData={setSearchData}
          showExport={false}
          showFilter={false}
          showReset={false}
          onExpand={false}
          rowCount={rowCount} // Pass rowCount to the Table component
          headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
          tableStyle={{
            border: "1px solid  #f0f0f0",
            borderRadius: "12px",
          }}
          onResourceRelease={handleResourceReleaseFromExpandedTable}
          onDataRefresh={getResourceDeployList}
          loader={loader}
        />

      </div>
      <style>{`
        /* Make room for the Export to Excel button so it sits to the
           right of the table's built-in search box instead of overlapping it. */
        .resource-alloc-table .table-search {
          margin-right: 72px;
        }
        /* Child combinators (not descendant selectors) so these rules only
           touch the outer table's own rows — the expanded "deployed
           resources" sub-table nested inside a td keeps its own borders. */
        .resource-alloc-table table.iccc--table > tbody > tr > td,
        .resource-alloc-table table.iccc--table > tbody > tr > th {
          border: none !important;
        }
        /* No !important on background-color: rows matched via
           highlightedIncidentId / highlightDeployIds set an inline
           background on the td, and inline styles already win over a
           non-important stylesheet rule regardless of specificity — so the
           highlight keeps working while unhighlighted rows get the zebra
           stripe below. */
        .resource-alloc-table table.iccc--table > tbody > tr > td {
          background-color: #fff;
          color: #1D2939 !important;
        }
        .resource-alloc-table table.iccc--table > tbody > tr:nth-child(even) > td {
          background-color: #F9FAFB;
        }
      `}</style>
      <Modal show={showReleaseModal} onHide={handleCancel} style={{ marginTop: '6rem' }} dialogClassName="custom-modal-width">
        {/* <Modal.Header closeButton>
          <Modal.Title>Release Resource</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          Are you sure you want to release the resources?
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <div className="d-flex gap-2" style={{ marginTop: "-2rem" }}>
            <Button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleRelease}>
              Release
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default DeploymentList;
